import { actionCreator } from '@blink/components/src/utils';

import {
    AGREEMENT_CONTRACT_ERROR,
    AGREEMENT_GENERAL_ERROR,
    AGREEMENT_ROLE_ERROR,
    AGREEMENTS_ERROR,
    ASSET_PRICE_ERROR,
    ASSET_PRICE_GENERAL_ERROR,
    CLEAR_ERRORS,
    COLLATERAL_AGREEMENT_ERROR,
    COLLATERAL_GENERAL_ERROR,
    COLLATERAL_TOKENS_ERROR,
    COLLATERAL_WALLET_ERROR,
    DEPOSIT_ERROR,
    INFO_ERROR,
    MARGIN_ACCOUNTS_ERROR,
    NETWORKS_ERROR,
    ORGANIZATION_MEMBERS_ERROR,
    TOKEN_BALANCE_ERROR,
    TOKEN_PRICE_ERROR,
    TOKENS_ERROR,
    USER_BORROWS_ERROR,
    USER_VAULTS_ERROR,
    USERS_SUPPLIES_ERROR,
    USERS_SUPPLIES_BALANCE_ERROR,
    USERS_SUPPLIES_PENDING_REWARDS_ERROR,
    USERS_VAULTS_PENDING_REWARDS_ERROR,
    VAULT_ERROR,
    WALLET_BALANCE_ERROR,
    WALLETS_ERROR,
    WITHDRAWAL_ERROR,
    AGREEMENT_FETCH_ERROR,
    REMOVE_AGREEMENT_CONTRACT_ERROR,
    AGREEMENT_LEVERAGE_ERROR,
    CLIENT_POOL_BY_ID_ERROR,
} from './constants';

export type ErrorActionProps = {
    message: string;
};

export type ClearErrorActionProps = {
    errorType: string;
};

export const clearErrorsAction = (payload: ClearErrorActionProps) =>
    actionCreator(CLEAR_ERRORS, payload);

export const usersSuppliesErrorAction = (payload: ErrorActionProps) =>
    actionCreator(USERS_SUPPLIES_ERROR, payload);

export const userBorrowsErrorAction = (payload: ErrorActionProps) =>
    actionCreator(USER_BORROWS_ERROR, payload);

export const addWalletsErrorAction = (payload: ErrorActionProps) =>
    actionCreator(WALLETS_ERROR, payload);

export const addNetworksErrorAction = (payload: ErrorActionProps) =>
    actionCreator(NETWORKS_ERROR, payload);

export const agreementErrorAction = (payload: ErrorActionProps) =>
    actionCreator(AGREEMENTS_ERROR, payload);

export const tokensErrorAction = (payload: ErrorActionProps) =>
    actionCreator(TOKENS_ERROR, payload);

export const infoErrorAction = (payload: ErrorActionProps) => actionCreator(INFO_ERROR, payload);

export const vaultErrorAction = (payload: ErrorActionProps) => actionCreator(VAULT_ERROR, payload);

export const usersVaultsErrorAction = (payload: ErrorActionProps) =>
    actionCreator(USER_VAULTS_ERROR, payload);

export const userMarginAccountsErrorAction = (payload: ErrorActionProps) =>
    actionCreator(MARGIN_ACCOUNTS_ERROR, payload);

export const withdrawalErrorAction = (payload: ErrorActionProps) =>
    actionCreator(WITHDRAWAL_ERROR, payload);

export const depositErrorAction = (payload: ErrorActionProps) =>
    actionCreator(DEPOSIT_ERROR, payload);

export const organizationMembersErrorAction = (payload: ErrorActionProps) =>
    actionCreator(ORGANIZATION_MEMBERS_ERROR, payload);

export const usersVaultsContractNotAvailableAction = (payload: ErrorActionProps) =>
    actionCreator(USER_VAULTS_ERROR, payload);

export const usersVaultsPendingRewardsErrorAction = (payload: ErrorActionProps) =>
    actionCreator(USERS_VAULTS_PENDING_REWARDS_ERROR, payload);

export const userSuppliesBalanceErrorAction = (payload: ErrorActionProps) =>
    actionCreator(USERS_SUPPLIES_BALANCE_ERROR, payload);

export const userSuppliesRewardsErrorAction = (payload: ErrorActionProps) =>
    actionCreator(USERS_SUPPLIES_PENDING_REWARDS_ERROR, payload);

export const collateralAgreementErrorAction = (payload: ErrorActionProps) =>
    actionCreator(COLLATERAL_AGREEMENT_ERROR, payload);

export const collateralWalletErrorAction = (payload: ErrorActionProps) =>
    actionCreator(COLLATERAL_WALLET_ERROR, payload);

export const collateralTokenErrorAction = (payload: ErrorActionProps) =>
    actionCreator(COLLATERAL_TOKENS_ERROR, payload);

export const collateralGeneralErrorAction = (payload: ErrorActionProps) =>
    actionCreator(COLLATERAL_GENERAL_ERROR, payload);

export const assetPriceErrorAction = (payload: ErrorActionProps) =>
    actionCreator(ASSET_PRICE_ERROR, payload);

export const assetPriceGeneralErrorAction = (payload: ErrorActionProps) =>
    actionCreator(ASSET_PRICE_GENERAL_ERROR, payload);

export const agreementFetchErrorAction = (payload: ErrorActionProps) =>
    actionCreator(AGREEMENTS_ERROR, payload);

export const tokenFetchErrorAction = (payload: ErrorActionProps) =>
    actionCreator(TOKENS_ERROR, payload);

export const agreementRoleErrorAction = (payload: ErrorActionProps) =>
    actionCreator(AGREEMENT_ROLE_ERROR, payload);

export const tokenPriceErrorAction = (payload: ErrorActionProps) =>
    actionCreator(TOKEN_PRICE_ERROR, payload);

export const agreementContractErrorAction = (payload: ErrorActionProps) =>
    actionCreator(AGREEMENT_CONTRACT_ERROR, payload);

export const agreementLeverageErrorAction = (payload: ErrorActionProps) =>
    actionCreator(AGREEMENT_LEVERAGE_ERROR, payload);

export const removeAgreementContractErrorAction = (payload: ErrorActionProps) =>
    actionCreator(REMOVE_AGREEMENT_CONTRACT_ERROR, payload);

export const agreementGeneralErrorAction = (payload: ErrorActionProps) =>
    actionCreator(AGREEMENT_GENERAL_ERROR, payload);

export const tokenBalanceErrorAction = (payload: ErrorActionProps) =>
    actionCreator(TOKEN_BALANCE_ERROR, payload);

export const walletBalanceErrorAction = (payload: ErrorActionProps) =>
    actionCreator(WALLET_BALANCE_ERROR, payload);

export const fetchAgreementsFromContractErrorAction = (payload: ErrorActionProps) =>
    actionCreator(AGREEMENT_FETCH_ERROR, payload);

export const clientPoolByIdErrorAction = (payload: ErrorActionProps) =>
    actionCreator(CLIENT_POOL_BY_ID_ERROR, payload);
